import { QGetTournaments } from "./QGetTournaments";
import { QGetTournamentDetails } from "./QGetTournamentDetails";
import { QGetTournamentWinners } from "./QGetTournamentWinners";
import { QGetOptInTournaments } from "./QGetOptInTournaments";
import { QOptIn } from "./QOptIn";
import { QGetLeaderboards } from "./QGetLeaderboards";
export const QueryBuilder = {
    getTournaments: QGetTournaments,
    getTournamentDetails: QGetTournamentDetails,
    getTournamentWinners: QGetTournamentWinners,
    getOptInTournaments: QGetOptInTournaments,
    optIn: QOptIn,
    getLeaderboards: QGetLeaderboards
};
//# sourceMappingURL=index.js.map